import React from 'react';

import cx from 'classnames';
import { IS_ACCELERATED_CURRICULUM_FILTER } from 'constants/assignments';

import styles from './styles.module.scss';

const TemplateFilters = ({ filters, setFilters }) => {
  const handleToggleAccelerated = () => {
    setFilters((prev) => {
      const nextAccelerated = !prev.is_accelerated;

      localStorage.setItem(
        IS_ACCELERATED_CURRICULUM_FILTER,
        JSON.stringify(nextAccelerated)
      );

      return {
        ...prev,
        is_accelerated: nextAccelerated
      };
    });
  };

  const handleSelectChange = ({ key, value }) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  return (
    <div className={styles.filterContainer}>
      {/* Accelerated Toggle */}
      <div className={styles.toggleRow} onClick={handleToggleAccelerated}>
        <div
          className={cx(styles.toggleSwitch, {
            [styles.active]: filters.is_accelerated
          })}
        >
          {filters.is_accelerated && <span className={styles.check}>✓</span>}
        </div>
        <span className={styles.toggleLabel}>Accelerated</span>
      </div>

      {/* Curriculum / Root */}
      <select
        className={styles.filterSelect}
        value={filters.root || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'root', value: e.target.value })
        }
      >
        <option value="">Curriculum</option>
        <option value="math_curriculum_1">Math Curriculum 1</option>
      </select>

      {/* Grade */}
      <select
        className={styles.filterSelect}
        value={filters.grade || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'grade', value: e.target.value })
        }
      >
        <option value="">Grade</option>
        <option value="5">Grade 5</option>
        <option value="6">Grade 6</option>
        <option value="7">Grade 7</option>
      </select>

      {/* Unit */}
      <select
        className={styles.filterSelect}
        value={filters.unit || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'unit', value: e.target.value })
        }
      >
        <option value="">Unit</option>
        <option value="1">Unit 1</option>
        <option value="2">Unit 2</option>
        <option value="3">Unit 3</option>
      </select>

      {/* Lesson */}
      <select
        className={styles.filterSelect}
        value={filters.lesson || ''}
        onChange={(e) =>
          handleSelectChange({ key: 'lesson', value: e.target.value })
        }
      >
        <option value="">Lesson</option>
        <option value="1">Lesson 1</option>
        <option value="2">Lesson 2</option>
        <option value="3">Lesson 3</option>
      </select>
    </div>
  );
};

export default TemplateFilters;
